import { useNavigate } from "react-router-dom"
import { useAuth, useLogin } from "../../hooks/useAuth"
import { useEffect, useState } from "react"
import TwoFaModal from "./components/TwoFaModal"
import {
  isOtpVerified,
  setOtpVerification,
  setTokensToLocalStorage,
  setUserToLocalStorage,
} from "../../utils"
import { userLoginSchema } from "./schema"
import { Form, Formik } from "formik"
import routePaths from "../../constants/path"
import TextField from "../../components/TextField"
import ApiError from "../../components/ApiError"
import Loader from "../../components/Loader"

function Login() {
  const navigate = useNavigate()
  const { mutate, isPending, error } = useLogin()
  const { user } = useAuth()
  const [openTwoFaModal, setOpenTwoFaModal] = useState(false)
  const otpVerified = isOtpVerified()

  useEffect(() => {
    if (user?.userId && !user?.twoFAEnabled) {
      setOpenTwoFaModal(true)
    } else if (user?.userId && user?.twoFAEnabled && !otpVerified) {
      navigate(routePaths.verifyTwoFa)
    } else if (user?.userId && user?.twoFAEnabled && otpVerified) {
      navigate(routePaths.homepage)
    }
  }, [navigate, otpVerified, user?.twoFAEnabled, user?.userId])

  const handleCloseTwoFAModal = () => {
    setOpenTwoFaModal(false)
    navigate(routePaths.homepage)
  }
  const handleSubmit = (values) => {
    const payload = { username: values.username, password: values.password }
    mutate(payload, {
      onSuccess: (res) => {
        setTokensToLocalStorage(res.accessToken, res.refreshToken)
        const user = res?.data
        setUserToLocalStorage(user)
        if (!user?.twoFAEnabled) {
          setOpenTwoFaModal(true)
        } else if (user?.userId && user?.twoFAEnabled && user?.rememberMe) {
          setOtpVerification(true)
          navigate(routePaths.homepage)
        } else if (user?.twoFAEnabled && !otpVerified) {
          navigate(routePaths.verifyTwoFa)
        }
      },
    })
  }
  return (
    <>
      <div className="flex flex-col gap-3 mt-4 w-[26rem] mx-auto px-12 py-8 bg-white rounded-lg">
        <h1 className="text-center text-3xl font-bold">Login</h1>
        <Formik
          enableReinitialize
          initialValues={{ username: "", password: "" }}
          validationSchema={userLoginSchema}
          onSubmit={handleSubmit}
        >
          <Form className="flex flex-col gap-3 mt-4">
            <TextField
              label="Username"
              name="username"
              placeholder="Enter Username"
            />
            <TextField
              label="Password"
              name="password"
              placeholder="Enter Password"
              type="password"
            />

            <ApiError axiosError={error} />

            <button
              className="mt-4 flex justify-center items-center gap-3 w-full bg-primary text-white px-4 py-2 rounded-lg disabled:opacity-60 disabled:cursor-not-allowed"
              disabled={isPending}
              type="submit"
            >
              {isPending && <Loader className="h-4 w-4 mb-1" />}
              Login
            </button>
          </Form>
        </Formik>
      </div>
      {openTwoFaModal && <TwoFaModal onClose={handleCloseTwoFAModal} />}
    </>
  )
}

export default Login
